'use client';
import type { ReactElement } from 'react';
import { Cimage } from '../Cimage';
import { Temper } from '@/types/frontend-types';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { TRIANGLE_IMAGES } from './messageModalConstants';
interface MessageModalTriangleProps {
    dataElScope: DataElScope;
    temper: Temper;
    isGlobalLayout: boolean;
}
export function MessageModalTriangle({ dataElScope, temper, isGlobalLayout, }: MessageModalTriangleProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'Triangle/Root')} style={{
            width: '120px',
            height: '120px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
        <Cimage src={TRIANGLE_IMAGES[temper]} alt={temper} static={true} priority={true} objectFit="contain" width="100%" height="100%" style={{
            width: '100%',
            height: '100%',
            ...(isGlobalLayout && { marginLeft: '15px' }),
        }}/>
      </div>
    );
}
